/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useState, useEffect } from "react";
//#endregion
//#region Styles
import { Column, Row } from "components/styles";
import{
    Container,
    Title
} from "./styles";
import { Description } from "./CardLinkItemV2Mod.styles";
//#endregion
//#region Components
import TooltipButton from "components/TooltipButton/TooltipButton";
//#endregion

const ROW_PROPS = {
    "primary": {},
    "secondary": {
        content: {
            minWidth: "unset",
            width: "100%",
            gap: "12px"
        },
        subcontent: {
            justifyContent: "flex-start",
            align: "flex-start",
            gap: "10px",
            width: "100%",
            wrap: "wrap"
        } 
    }
};
const CardLinkItemV2 = ({
    className,
    title, icon, to,
    description,
    tooltip,
    variant = "primary",
    ...rest
}) => {
    const [tooltipProps, setTooltipProps] = useState({ ...(tooltip?.props?.maxSize || {}) });
    useEffect(() => {
        if (!tooltip) return;
        const handlerResizeWindow = () => {
            setTooltipProps(
                window.innerWidth > 1220 
                ? { ...tooltip.props.maxSize } 
                : { ...tooltip.props.minSize });
        }
        handlerResizeWindow();
        window.addEventListener("resize", handlerResizeWindow);
        return () => window.removeEventListener("resize", handlerResizeWindow);
    }, [tooltip]);
    const getClassName = () => {
        return [variant, className].join(" ");
    }
    const rowPropsValue = ROW_PROPS[variant];
    return (
        <Container className={getClassName()} to={to} {...rest}>
            <Column {...rowPropsValue.content}>
                <Row align="center">{icon}</Row>
                <Row {...rowPropsValue.subcontent}>
                    <Title className={variant}>{title}</Title>
                    {tooltip && (
                        <TooltipButton 
                            tooltipProps={tooltipProps}
                            message={tooltip.message}/>
                    )}
                </Row>
                {description && <Description>{description}</Description>}
            </Column>
        </Container>
    );
}

export default CardLinkItemV2;
